import { loginFeature } from './login.reducer';

export const {
  selectUsername,
  selectSessionToken,
  selectLoginMethod,
  selectPassword,
  selectGoogleAuthRequired,
  selectGoogleAuthSetupRequired,
  selectGoogleAuthSetup,
  selectCanGoToStep,
  selectLoading,
  selectError,
  selectLoginState,
} = loginFeature;
